import {
    CaptchaToken,
    VerifyCaptcha
} from "@pledger/frontend-commons/dist/ui/components/reCaptcha/ReCaptchaContainedProps";

export const ResetPasswordActions = {

    RESET_PASSWORD_CHANGE_EMAIL_ACTION : { type : 'ChangePhoneNumberActions.RESET_PASSWORD_CHANGE_EMAIL_ACTION', build : (email: string) => {return {type: ResetPasswordActions.RESET_PASSWORD_CHANGE_EMAIL_ACTION.type, payload:{email}}}},
    RESET_PASSWORD_CHANGE_IDENTIFIER_ACTION : { type : 'ChangePhoneNumberActions.RESET_PASSWORD_CHANGE_IDENTIFIER_ACTION', build : (identifier: string) => {return {type: ResetPasswordActions.RESET_PASSWORD_CHANGE_IDENTIFIER_ACTION.type, payload:{identifier}}}},

    REGISTER_INVALID_CAPTCHA: {type: 'ResetPasswordActions.REGISTER_INVALID_CAPTCHA', build: () => {return {type: ResetPasswordActions.REGISTER_INVALID_CAPTCHA.type,payload:{}}}},
    UPDATE_CAPTCHA_ACTION: {type: 'ResetPasswordActions.UPDATE_CAPTCHA_ACTION', build: (captchaReady : boolean,verifyCaptcha? : VerifyCaptcha) => {return {type: ResetPasswordActions.UPDATE_CAPTCHA_ACTION.type,payload:{captchaReady,verifyCaptcha}}}},
    UPDATE_CAPTCHA_TOKEN_ACTION: {type: 'ResetPasswordActions.UPDATE_CAPTCHA_TOKEN_ACTION', build: (captchaToken : CaptchaToken) => {return {type: ResetPasswordActions.UPDATE_CAPTCHA_TOKEN_ACTION.type,payload:{captchaToken}}}},

};
